import useTeamInvitation from '../../auth/useTeamInvitation';
import React from "react";
import usePricingPlans from '../usePricingPlans';
import { useNavigate } from 'react-router-dom';

import "./PricingPlans.scss";
import PricingPlan from "../Plans/YearlyPlan";
import MonthlyPlan from "../Plans/MonthlyPlans";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Planarrow from "../../../assets/icons/Big arrow.svg";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PricingPlans() {
  const navigate = useNavigate();
  const { priceListY, priceListM, isLoading, error } = usePricingPlans(false);

  useTeamInvitation('subscription');

  const createSubscription = async (planId, priceId, type, planPrice) => {
    localStorage.setItem('subscriptionType', type);
    localStorage.setItem('subscriptionplanId', planId);
    localStorage.setItem('subscriptionpriceId', priceId);
    localStorage.setItem('planPrice', planPrice);
    navigate('/app/planCheckout');
    // const token = localStorage.getItem('token');
    // try{
    //   const response = await axios.get(
    //     `${process.env.REACT_APP_API}subscriptions/attach-paymentMethod`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`, // Include the token in the request header
    //       },
    //     }
    //   ); // Replace this with the actual API endpoint
    //   if(response.data.data.client_secret){
    //     localStorage.setItem('subscriptionType',type);
    //     localStorage.setItem('subscriptionplanId',planId);
    //     localStorage.setItem('subscriptionpriceId',priceId);
    //     localStorage.setItem('planPrice',planPrice);
    //     localStorage.setItem('subscriptionclientSecret',response.data.data.client_secret);
    //     navigate('/app/planCheckout?clientSecret='+response.data.data.client_secret); // Redirect to your checkout page
    //   }
    // } catch (error) {
    //   console.error(error);
    //   toastify("error", error.response.data.message );
    // }
    // try {
    //   const response = await axios.post(`${process.env.REACT_APP_API}subscriptions/create`, { priceId:priceId,planId:planId},
    //   {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //       }
    //   }
    //   );
    //   if(response.data.data.clientSecret){
    //       localStorage.setItem('subscriptionType',type);
    //       localStorage.setItem('subscriptionplanId',planId);
    //       localStorage.setItem('subscriptionpriceId',priceId);
    //       localStorage.setItem('planPrice',planPrice);
    //       localStorage.setItem('subscriptionclientSecret',response.data.data.clientSecret);
    //       localStorage.setItem('subscriptionId',response.data.data.subscriptionId);
    //       navigate('/app/planCheckout?clientSecret='+response.data.data.clientSecret); // Redirect to your checkout page
    //       // localStorage.setItem('subscription')
    //   }
    //   // toastify("success", response.data.data.clientSecret);
    // } catch (error) {
    //   console.error(error);
    //   toastify("error", error.response.data.data.message );
    // }
  }
  if (error) return <div role="alert">{error}</div>;
  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="pricing-plans">
          <div className="page-heading">
            <h3>Pricing Plans</h3>
            <p>Choose the perfect plan for you</p>
          </div>
          <div className="save-plan">
            <div className="sec-sectio">
              <h6>Save up to 33%</h6>
              <img src={Planarrow} alt="chrome-icon" />
            </div>
          </div>
          <Tabs>
            <TabList>
              <Tab>Monthly</Tab>
              <Tab>Yearly</Tab>
            </TabList>
            <TabPanel>
              <MonthlyPlan priceListM={priceListM} createSubscription={createSubscription} />
            </TabPanel>
            <TabPanel>
              <PricingPlan priceListY={priceListY} createSubscription={createSubscription} />
            </TabPanel>
          </Tabs>
          <ToastContainer />
        </div>
      )}
    </>
  );
}
export default PricingPlans;
